import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UIState {
  isDrawerOpen: boolean;
}

const initialState: UIState = {
  isDrawerOpen: false,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setIsDrawerOpen: (state, action: PayloadAction<boolean>) => {
      state.isDrawerOpen = action.payload;
    },
    toggleDrawer: state => {
      state.isDrawerOpen = !state.isDrawerOpen;
    },
  },
});

export const { setIsDrawerOpen, toggleDrawer } = uiSlice.actions;
export default uiSlice.reducer;
